//Below contains all the categories of the auction which is going to be listed on website
const AuctionCategoriesData = [
  {
    label: 'Paintings',
    value: 'paintings',
    children: [
      {
        label: 'StoryLine',
        value: 'paintings/storyline',
        visible: true
      },
      {
        label: 'Woman',
        value: 'paintings/woman',
        visible: true
      },
      {
        label: 'Geometric',
        value: 'paintings/geometric',
        visible: true
      },
      {
        label: 'Abstract',
        value: 'paintings/abstract',
        visible: true
      },
      {
        label: 'Animal Life',
        value: 'paintings/animal-life',
        visible: true
      },
      {
        label: 'Architecture',
        value: 'paintings/architecture',
        visible: true
      },
      {
        label: 'Landscape',
        value: 'paintings/landscape',
        visible: true
      },
      {
        label: 'Portraits',
        value: 'paintings/portraits',
        visible: true
      },
      {
        label: 'Still Life',
        value: 'paintings/still-life',
        visible: true
      },
      {
        label: 'Sufi',
        value: 'paintings/sufi',
        visible: true
      }
    ],
    visible: true
  },
  {
    label: 'Drawings',
    value: 'drawings',
    children: [
      {
        label: 'Woman',
        value: 'drawings/woman',
        visible: true
      },
      {
        label: 'Abstract',
        value: 'drawings/abstract',
        visible: true
      },
      {
        label: 'Animal Life',
        value: 'drawings/animal-life',
        visible: true
      },
      {
        label: 'Architecture',
        value: 'drawings/architecture',
        visible: true
      },
      {
        label: 'Landscape',
        value: 'drawings/landscape',
        visible: true
      },
      {
        label: 'Pop Art',
        value: 'drawings/pop-art',
        visible: true
      },
      {
        label: 'Portraits',
        value: 'drawings/portraits',
        visible: true
      },
      {
        label: 'Still Life',
        value: 'drawings/still-life',
        visible: true
      }
    ],
    visible: true
  },
  {
    label: 'Caligraphy',
    value: 'caligraphy',
    visible: true
  },
  {
    label: 'Fabric Products',
    value: 'fabric-products',
    children: [
      {
        label: 'Shoes',
        value: 'fabric-products/shoes',
        visible: true
      }
    ],
    visible: true
  },
  {
    label: 'Mandalas',
    value: 'mandalas',
    visible: true
  },
  {
    label: 'Modern',
    value: 'modern',
    visible: true
  },
  {
    label: 'Religious',
    value: 'religious',
    visible: true
  },
  {
    label: 'Cubism',
    value: 'cubism',
    visible: true
  },
  {
    label: 'Fantasy',
    value: 'fantasy',
    visible: true
  },
  {
    label: 'Graffiti',
    value: 'graffiti',
    visible: true
  },
  {
    label: 'Sculpture',
    value: 'sculpture',
    visible: true
  }
];

export default AuctionCategoriesData;
